module.exports = __webpack_public_path__ + "img/noNotificationillustration.0a44f1eb.svg";